import { Component, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var portletNameCardRequestLiferay: any; // Nombre del portlet en Liferay
declare var JsonGetContent: any; // URL del contenido con las condiciones del servicio
declare var privaciPolicyIdLiferay: any; // Identificador del contenido con las condiciones del servicio
declare var i18nVS: any;
declare var showServiceTermsLiferay: any;

/*--------------------------------------------- Variables Globales ---------------------------------------------*/
@Component({
    selector: 'app-service-terms',
    templateUrl: './serviceTerms.component.html',
    styleUrls: ['../solicitud-tarjeta.component.css']
})

export class ServiceTermsComponent implements OnInit {
    /*---------------------------------------------- Constantes ----------------------------------------------*/

    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    portletName = ''; // Nombre del portlet

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    URLContenido: string;
    theHtmlString = '';
    i18nL = i18nVS;
    showServiceTerms = false;

    public getContents(PLID: string) {
        this.leerDatos(PLID).subscribe(res => this.comprobandoJson(res));
    }

    public comprobandoJson(res) {
        var resultado: string = res._body;
        this.theHtmlString = resultado;
    }

    public leerDatos(PLID: string): Observable<Response> {
        var body = portletNameCardRequestLiferay + 'contentPLID=' + PLID;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // Set content type to JSON
        const options = new RequestOptions({ headers: headers }); // Create a request option
        // console.log("terminos:"+PLID);
        // console.log("JsonGetContent:"+JsonGetContent);
        return this.http.post(JsonGetContent, body, options);
    }

    public onSubmitForm() {
        // Desde las condiciones de uso y servicio mandamos el formulario
        (<HTMLFormElement>document.getElementById(this.portletName + 'cardRequestForm')).submit();
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameCardRequestLiferay;
        this.showServiceTerms = showServiceTermsLiferay;
        if (this.showServiceTerms) {
            this.getContents(privaciPolicyIdLiferay);
        }
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http) { }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
}



// WEBPACK FOOTER //
// ./src/app/serviceTerms/serviceTerms.component.ts